import { useEffect, useState } from "react";
import AuthorListItem from "./components/AuthorListItem";
import AuthorModal from "./modal/AuthorModal";
import PaginationComponent from "../../components/PaginationComponent";
import "./subdomain.css";
import withRoleBased from "../../utils/Functions/withRoleBased";
import useAuthorList from "../../utils/CustomHooks/useAuthorList";
import { sortArray } from "../../utils/Functions/filter";

function SubDomain({ access }) {
  const [isOpen, setIsOpen] = useState(false);
  const [count, setCount] = useState(0);
  const { authorList, getAuthorList } = useAuthorList(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const pageCount = Math.ceil(authorList.length / pageSize);
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };
  useEffect(() => {
    let req = {};
    if (search) req.author_name = search;
    getAuthorList(req);
  }, [count]);
  const onSearch = () => {
    setCurrentPage(0)
    setCount((x) => x + 1);
    setIsSearch(search ? true : false);
  };
  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row m-0 w-100">
          <div className="col-md-6 mb-3">
            <h5 className="page-title"> Author </h5>
          </div>
          <div className="col-md-6  mb-3 d-flex justify-content-md-end">
            {access.canCreate && (
              <button
                type="button"
                className="btn btn-outline-success "
                onClick={() => setIsOpen(true)}
              >
                Add Author
              </button>
            )}
          </div>

          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-borderless ">
                <thead>
                  <tr>
                    <td className="col-sm-3">Name</td>
                    <td className={access.canEdit ? "col-sm-5" : "col-sm-7"}>
                      Description{" "}
                    </td>
                    <td className="col-sm-2">Status</td>
                    {access.canEdit && <td className="col-sm-2">Action</td>}
                  </tr>
                </thead>
                <tbody>
                  {authorList && authorList.length > 0 ? (
                    sortArray(authorList)
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((x, i) => (
                        <AuthorListItem
                          item={x}
                          index={i}
                          key={i}
                          refresh={() => setCount((x) => x + 1)}
                          access={access}
                        />
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="font-weight-bold">
                          Oops! No Data Found
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {authorList.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}
        <AuthorModal
          isOpen={isOpen}
          setOpen={() => setIsOpen(false)}
          refresh={() => setCount((x) => x + 1)}
        />
      </div>
    </main>
  );
}
export default withRoleBased(SubDomain, "blog");
